export class CompatibilityTablesDescriptorParser {
    constructor(doc) {
        this.doc = doc;
        this.compatibilityTablesDescriptor = [];
    }
    parse() {
        this.compatibilityTablesDescriptor = [];
        if (hasCompatibleTables(this.doc)) {
            if (Array.isArray(this.doc.compatibilityTables)) {
                for (let i = 0; i < this.doc.compatibilityTables.length; i++) {
                    let tableDescriptor = this.doc.compatibilityTables[i];
                    this.parseTableDescriptor(tableDescriptor, i);
                }
            }
            else {
                this.throwError(`Field 'compatibleTables' should be an array`);
            }
        }
        return this.compatibilityTablesDescriptor;
    }
    throwError(message) {
        throw new TypeError(`Incorrect type definition of compatibilityTables for ${this.doc.name}. ${message}`);
    }
    parseTableDescriptor(tableDescriptor, index) {
        this.nextTable = {};
        if ('name' in tableDescriptor) {
            if (typeof tableDescriptor.name === 'string') {
                this.nextTable.name = tableDescriptor.name;
            }
            else {
                this.throwError(`Field 'name' should be a string in compatibilityTables at ${index} position`);
            }
        }
        else {
            this.throwError(`Field 'name' is missing in compatibilityTables at ${index} position`);
        }
        this.nextTable.properties = [];
        if ('properties' in tableDescriptor) {
            if (Array.isArray(tableDescriptor.properties)) {
                this.parseProperties(tableDescriptor.properties, index);
            }
            else {
                this.throwError(`Field 'properties' should be a an array in compatibilityTables at ${index} position`);
            }
        }
        else {
            this.throwError(`Field 'properties' is missing`);
        }
        this.compatibilityTablesDescriptor.push(this.nextTable);
    }
    parseProperties(properties, index) {
        for (let i = 0; i < properties.length; i++) {
            let prop = properties[i];
            if (typeof prop === 'string') {
                this.nextTable.properties.push(prop);
            }
            else {
                this.throwError(`Property at ${i} in compatibilityTables at ${index} should be a string`);
            }
        }
    }
}
function hasCompatibleTables(v) {
    return 'compatibilityTables' in v;
}
//# sourceMappingURL=CompatibilityTablesDescriptorParser.js.map